export default {
  "hierarchy": {
    "primary": [
      "button-primary"
    ],
    "secondary": [
      "button-secondary"
    ],
    "tertiary": [
      "button-tertiary"
    ],
    "primaryIconic": [
      "button-primary",
      "button-primaryIconic"
    ],
    "secondaryIconic": [
      "button-secondary",
      "button-secondaryIconic"
    ],
    "tertiaryIconic": [
      "button-tertiary",
      "button-tertiaryIconic"
    ],
    "primarySmall": [
      "button-primary",
      "button-primarySmall"
    ],
    "secondarySmall": [
      "button-secondary",
      "button-secondarySmall"
    ],
    "tertiarySmall": [
      "button-tertiary",
      "button-tertiarySmall"
    ],
    "primarySmallIconic": [
      "button-primary",
      "button-primaryIconic",
      "button-primarySmallIconic"
    ],
    "secondarySmallIconic": [
      "button-secondary",
      "button-secondaryIconic",
      "button-secondarySmallIconic"
    ],
    "tertiarySmallIconic": [
      "button-tertiary",
      "button-tertiaryIconic",
      "button-tertiarySmallIconic"
    ],
    "primaryTinyIconic": [
      "button-primary",
      "button-primaryIconic",
      "button-primarySmallIconic",
      "button-primaryTinyIconic"
    ],
    "secondaryTinyIconic": [
      "button-secondary",
      "button-secondaryIconic",
      "button-secondarySmallIconic",
      "button-secondaryTinyIconic"
    ],
    "tertiaryTinyIconic": [
      "button-tertiary",
      "button-tertiaryIconic",
      "button-tertiarySmallIconic",
      "button-tertiaryTinyIconic"
    ],
    "link": [
      "button-link"
    ],
    "linkDestructive": [
      "button-link",
      "button-linkDestructive"
    ],
    "linkTable": [
      "button-link",
      "button-linkTable"
    ],
    "primaryDestructive": [
      "button-primary",
      "button-primaryDestructive"
    ],
    "primaryCancel": [
      "button-tertiary",
      "button-primaryCancel"
    ],
    "desktopSearch": [
      "button-desktopSearch"
    ],
    "tableColumnAdd": [
      "button-secondary",
      "button-tableColumnAdd"
    ],
    "tableColumnRemove": [
      "button-primary",
      "button-primaryIconic",
      "button-primarySmallIconic",
      "button-primaryTinyIconic",
      "button-tableColumnRemove"
    ],
    "close": [
      "button-tertiary",
      "button-tertiaryIconic",
      "button-tertiarySmallIconic",
      "button-tertiaryTinyIconic",
      "button-close"
    ],
    "navLogo": [
      "button-navLogo"
    ],
    "navRefresh": [
      "button-navRefresh"
    ],
    "pagination": [
      "button-secondary",
      "button-secondaryIconic",
      "button-secondarySmallIconic",
      "button-pagination"
    ],
    "mobileAction": [
      "button-tertiary",
      "button-mobileAction"
    ],
    "mobileNavIcon": [
      "button-tertiary",
      "button-tertiaryIconic",
      "button-tertiarySmallIconic",
      "button-mobileNavIcon"
    ],
    "mobileNavTitle": [
      "button-tertiary",
      "button-mobileNavTitle"
    ],
    "closeToast": [
      "button-tertiary",
      "button-tertiaryIconic",
      "button-tertiarySmallIconic",
      "button-closeToast"
    ],
    "mapControl": [
      "button-primary",
      "button-primaryIconic",
      "button-primarySmallIconic",
      "button-primaryTinyIconic",
      "button-mapControl"
    ],
    "zoomControl": [
      "button-primary",
      "button-primaryIconic",
      "button-primarySmallIconic",
      "button-primaryTinyIconic",
      "button-mapControl",
      "button-zoomControl"
    ],
    "clearSearch": [
      "button-tertiary",
      "button-tertiaryIconic",
      "button-tertiarySmallIconic",
      "button-tertiaryTinyIconic",
      "button-clearSearch"
    ],
    "closeWindow": [
      "button-tertiary",
      "button-tertiaryIconic",
      "button-tertiarySmallIconic",
      "button-closeWindow"
    ],
    "itemBar": [
      "button-tertiary",
      "button-itemBar"
    ],
    "hNavBar": [
      "button-tertiary",
      "button-hNavBar"
    ],
    "sideNavBar": [
      "button-tertiary",
      "button-hNavBar",
      "button-sideNavBar"
    ],
    "actionBar": [
      "button-tertiary",
      "button-itemBar",
      "button-actionBar"
    ],
    "cog": [
      "button-primary",
      "button-primaryIconic",
      "button-cog"
    ],
    "mobileNavLogo": [
      "button-navLogo",
      "button-mobileNavLogo"
    ],
    "paginationPrev": [
      "button-secondary",
      "button-secondaryIconic",
      "button-secondarySmallIconic",
      "button-pagination",
      "button-paginationPrev"
    ],
    "paginationNext": [
      "button-secondary",
      "button-secondaryIconic",
      "button-secondarySmallIconic",
      "button-pagination",
      "button-paginationNext"
    ],
    "mobileUserNavBar": [
      "button-mobileUserNavBar"
    ],
    "mobileScreenTitle": [
      "button-tertiary",
      "button-mobileScreenTitle"
    ],
    "mobileActionBar": [
      "button-tertiary",
      "button-mobileActionBar"
    ],
    "mapActionBar": [
      "button-tertiary",
      "button-itemBar",
      "button-actionBar",
      "button-mapActionBar"
    ],
    "touchToolbarButton": [
      "button-link",
      "button-touchToolbarButton"
    ],
    "linkNoPad": [
      "button-link",
      "button-linkNoPad"
    ],
    "pairOption": [
      "button-primary",
      "button-pairOption"
    ],
    "unpairOption": [
      "button-secondary",
      "button-unpairOption"
    ],
    "searchBack": [
      "button-link",
      "button-searchBack"
    ],
    "pairClose": [
      "button-link",
      "button-searchBack",
      "button-pairClose"
    ],
    "pairCamera": [
      "button-tertiary",
      "button-tertiaryIconic",
      "button-tertiarySmallIconic",
      "button-pairCamera"
    ],
    "backToLogin": [
      "button-link",
      "button-linkNoPad",
      "button-backToLogin"
    ],
    "expiredActivationTokenSubmit": [
      "button-primary",
      "button-expiredActivationTokenSubmit"
    ],
    "mobileClose": [
      "button-tertiary",
      "button-tertiaryIconic",
      "button-tertiarySmallIconic",
      "button-tertiaryTinyIconic",
      "button-close",
      "button-mobileClose"
    ],
    "mobileNavBack": [
      "button-tertiary",
      "button-mobileNavBack"
    ],
    "itemBarMobile": [
      "button-tertiary",
      "button-itemBar",
      "button-itemBarMobile"
    ],
    "mobileNavClose": [
      "button-mobileNavClose"
    ],
    "layoutSelector": [
      "button-secondary",
      "button-secondaryIconic",
      "button-layoutSelector"
    ],
    "mobileOptBarMore": [
      "button-link",
      "button-mobileOptBarMore"
    ],
    "confirmActionBar": [
      "button-secondary",
      "button-confirmActionBar"
    ],
    "rejectActionBar": [
      "button-secondary",
      "button-rejectActionBar"
    ],
    "multiSelector": [
      "button-link",
      "button-multiSelector"
    ],
    "closeDialog": [
      "button-tertiary",
      "button-tertiaryIconic",
      "button-tertiarySmallIconic",
      "button-tertiaryTinyIconic",
      "button-closeDialog"
    ],
    "primaryFullWidth": [
      "button-primary",
      "button-primaryFullWidth"
    ],
    "formSearchBarPost": [
      "button-tertiary",
      "button-tertiaryIconic",
      "button-tertiarySmallIconic",
      "button-tertiaryTinyIconic",
      "button-closeDialog",
      "button-formSearchBarPost"
    ],
    "copyHoursSubmit": [
      "button-secondary",
      "button-copyHoursSubmit"
    ],
    "linkDestructiveNoPad": [
      "button-link",
      "button-linkDestructive",
      "button-linkDestructiveNoPad"
    ],
    "linkNeutral": [
      "button-link",
      "button-linkNeutral"
    ],
    "linkNeutralNoPad": [
      "button-link",
      "button-linkNeutral",
      "button-linkNeutralNoPad"
    ],
    "sortFilterBar": [
      "button-filterBar",
      "button-sortFilterBar"
    ],
    "quaternary": [
      "button-tertiary",
      "button-quaternary"
    ],
    "copyToClipboard": [
      "button-secondary",
      "button-secondarySmall",
      "button-copyToClipboard"
    ],
    "copyToClipboardButton": [
      "button-secondary",
      "button-secondarySmall",
      "button-copyToClipboard",
      "button-copyToClipboardButton"
    ],
    "conditionBar": [
      "button-tertiary",
      "button-itemBar",
      "button-actionBar",
      "button-conditionBar"
    ],
    "sortAdd": [
      "button-sortAdd"
    ],
    "confirmMobileActionBar": [
      "button-secondary",
      "button-confirmActionBar",
      "button-confirmMobileActionBar"
    ],
    "rejectMobileActionBar": [
      "button-secondary",
      "button-rejectActionBar",
      "button-rejectMobileActionBar"
    ],
    "uploadFile": [
      "button-secondary",
      "button-uploadFile"
    ],
    "viewImage": [
      "button-secondary",
      "button-viewImage"
    ],
    "secondarySmallLeftIcon": [
      "button-secondary",
      "button-secondarySmall",
      "button-secondarySmallLeftIcon"
    ],
    "dangerSmallLeftIcon": [
      "button-secondary",
      "button-secondarySmall",
      "button-secondarySmallLeftIcon",
      "button-dangerSmallLeftIcon"
    ],
    "menuItem": [
      "button-menuItem"
    ],
    "mobileOptBack": [
      "button-tertiary",
      "button-mobileNavBack",
      "button-mobileOptBack"
    ],
    "linkNeutralSmall": [
      "button-link",
      "button-linkNeutral",
      "button-linkNeutralNoPad",
      "button-linkNeutralSmall"
    ],
    "ruleApply": [
      "button-secondary",
      "button-confirmActionBar",
      "button-ruleApply"
    ],
    "ruleRevert": [
      "button-secondary",
      "button-rejectActionBar",
      "button-ruleRevert"
    ],
    "editImage": [
      "button-secondary",
      "button-viewImage",
      "button-editImage"
    ],
    "fakeList": [
      "button-link",
      "button-fakeList"
    ],
    "tableGotoLink": [
      "button-link",
      "button-tableGotoLink"
    ],
    "customText": [
      "button-primary",
      "button-customText"
    ],
    "secondaryDestructive": [
      "button-secondary",
      "button-secondaryDestructive"
    ],
    "submit": [
      "button-submit"
    ],
    "copyToClipboardIcon": [
      "button-secondary",
      "button-secondarySmall",
      "button-copyToClipboard",
      "button-copyToClipboardIcon"
    ],
    "customTextMenu": [
      "button-tertiary",
      "button-itemBar",
      "button-actionBar",
      "button-customTextMenu"
    ],
    "viewImages": [
      "button-secondary",
      "button-viewImage",
      "button-viewImages"
    ],
    "tvCollectionViewItem": [
      "button-tvCollectionViewItem"
    ],
    "tvNavLogo": [
      "button-navLogo",
      "button-tvNavLogo"
    ],
    "linkLarge": [
      "button-link",
      "button-linkLarge"
    ],
    "altLoginMethod": [
      "button-secondary",
      "button-altLoginMethod"
    ],
    "forgotPasswordLink": [
      "button-link",
      "button-linkNoPad",
      "button-forgotPasswordLink"
    ],
    "altLoginMethodSmall": [
      "button-secondary",
      "button-altLoginMethod",
      "button-altLoginMethodSmall"
    ],
    "revert": [
      "button-secondary",
      "button-secondarySmall",
      "button-secondarySmallLeftIcon",
      "button-revert"
    ],
    "confirmActionBarSmall": [
      "button-secondary",
      "button-confirmActionBar",
      "button-confirmActionBarSmall"
    ],
    "rejectActionBarSmall": [
      "button-secondary",
      "button-rejectActionBar",
      "button-rejectActionBarSmall"
    ],
    "confirmAdd": [
      "button-confirmAdd"
    ],
    "rejectAdd": [
      "button-rejectAdd"
    ],
    "confirmDelete": [
      "button-rejectAdd",
      "button-confirmDelete"
    ],
    "aggregationLabel": [
      "button-link",
      "button-linkNoPad",
      "button-aggregationLabel"
    ],
    "aggregationValue": [
      "button-link",
      "button-linkNoPad",
      "button-aggregationLabel",
      "button-aggregationValue"
    ],
    "aggregationTitle": [
      "button-link",
      "button-linkNoPad",
      "button-aggregationLabel",
      "button-aggregationTitle"
    ],
    "rsrcImageDetailTitle": [
      "button-link",
      "button-linkNoPad",
      "button-rsrcImageDetailTitle"
    ],
    "rsrcActionBar": [
      "button-tertiary",
      "button-itemBar",
      "button-actionBar",
      "button-rsrcActionBar"
    ],
    "rsrcFilterByCreatedAt": [
      "button-tertiary",
      "button-tertiaryIconic",
      "button-rsrcFilterByCreatedAt"
    ],
    "sortFilterToolbar": [
      "button-filterBar",
      "button-sortFilterBar",
      "button-sortFilterToolbar"
    ],
    "sortFilterToolbarRight": [
      "button-filterBar",
      "button-sortFilterBar",
      "button-sortFilterToolbar",
      "button-sortFilterToolbarRight"
    ],
    "add": [
      "button-add"
    ],
    "project": [
      "button-project"
    ],
    "delete": [
      "button-delete"
    ],
    "tertiaryGray": [
      "button-tertiary",
      "button-tertiaryGray"
    ],
    "import": [
      "button-secondary",
      "button-import"
    ]
  },
  "props": {
    "default": {},
    "primary": {},
    "secondary": {},
    "tertiary": {},
    "primaryIconic": {},
    "secondaryIconic": {},
    "tertiaryIconic": {},
    "primarySmall": {},
    "secondarySmall": {},
    "tertiarySmall": {},
    "primarySmallIconic": {},
    "secondarySmallIconic": {},
    "tertiarySmallIconic": {},
    "primaryTinyIconic": {},
    "secondaryTinyIconic": {},
    "tertiaryTinyIconic": {},
    "link": {},
    "linkDestructive": {},
    "linkTable": {},
    "primaryDestructive": {},
    "primaryCancel": {},
    "desktopSearch": {},
    "tableColumnAdd": {
      "icon": ".lv-plus"
    },
    "tableColumnRemove": {},
    "close": {
      "icon": ""
    },
    "navLogo": {
      "icon": "https://storage.googleapis.com/molten-ui-assets/architect-logo.png",
      "imageOpts": {
        "height": "40px",
        "width": "40px"
      }
    },
    "navRefresh": {},
    "pagination": {},
    "mobileAction": {},
    "mobileNavIcon": {},
    "mobileNavTitle": {
      "imageOpts": {
        "height": "24px",
        "width": "24px"
      }
    },
    "closeToast": {},
    "mapControl": {},
    "zoomControl": {},
    "clearSearch": {},
    "closeWindow": {},
    "itemBar": {
      "iconOpts": {
        "style": {
          "fontSize": "18px"
        }
      },
      "imageOpts": {
        "height": "20px",
        "width": "20px"
      }
    },
    "hNavBar": {},
    "sideNavBar": {},
    "actionBar": {
      "iconOpts": {
        "style": {
          "fontSize": "16px"
        }
      },
      "imageOpts": {
        "height": "20px",
        "width": "20px"
      }
    },
    "cog": {
      "icon": "fa fa-cog"
    },
    "mobileNavLogo": {
      "icon": "https://storage.googleapis.com/molten-ui-assets/Customer%20Logos/leverege.svg",
      "imageOpts": {
        "width": "168px"
      }
    },
    "paginationPrev": {
      "icon": "fak fa-lv-chevron-left-small",
      "iconOpts": {
        "style": {
          "border": "",
          "fontSize": "",
          "padding": "0 4px 0 0"
        }
      }
    },
    "paginationNext": {
      "icon": "fak fa-lv-chevron-right-small",
      "iconOpts": {
        "style": {
          "padding": "0 0 0 4px"
        }
      }
    },
    "mobileUserNavBar": {},
    "mobileScreenTitle": {
      "iconOpts": {
        "style": {
          "background": "var(--color-brand025)",
          "borderRadius": "2px",
          "color": "var(--color-brand500)",
          "padding": "4px"
        }
      },
      "imageOpts": {
        "height": "24px",
        "width": "24px"
      }
    },
    "mobileActionBar": {
      "iconOpts": {
        "style": {
          "fontSize": "18px"
        }
      },
      "imageOpts": {
        "height": "20px",
        "width": "20px"
      }
    },
    "mapActionBar": {
      "iconOpts": {
        "style": {
          "fontSize": "16px"
        }
      },
      "imageOpts": {
        "height": "20px",
        "width": "20px"
      }
    },
    "touchToolbarButton": {},
    "linkNoPad": {},
    "pairOption": {
      "imageOpts": {
        "height": "16px",
        "width": "16px"
      }
    },
    "unpairOption": {
      "iconOpts": {
        "style": {
          "fontSize": "18px"
        }
      },
      "imageOpts": {
        "height": "16px",
        "width": "16px"
      }
    },
    "searchBack": {
      "icon": "fa fa-chevron-left",
      "imageOpts": {
        "height": "18px",
        "width": "18px"
      }
    },
    "pairClose": {
      "icon": "fa fa-close",
      "imageOpts": {
        "height": "18px",
        "width": "18px"
      }
    },
    "pairCamera": {
      "imageOpts": {
        "height": "16px",
        "width": "16px"
      }
    },
    "backToLogin": {
      "icon": "@icon:arrow-left",
      "iconOpts": {
        "style": {
          "fontSize": "16px"
        }
      }
    },
    "expiredActivationTokenSubmit": {},
    "mobileClose": {
      "icon": "@icon:close",
      "iconOpts": {
        "style": {
          "color": "",
          "fontSize": "16px"
        }
      }
    },
    "mobileNavBack": {
      "icon": "fak fa-lv-chevron-left-large",
      "iconOpts": {
        "style": {
          "fontSize": "16px"
        }
      }
    },
    "itemBarMobile": {
      "iconOpts": {
        "style": {
          "fontSize": "18px"
        }
      },
      "imageOpts": {
        "height": "20px",
        "width": "20px"
      }
    },
    "mobileNavClose": {
      "iconOpts": {
        "style": {
          "fontSize": "24px"
        }
      },
      "imageOpts": {
        "height": "24px",
        "width": "24px"
      }
    },
    "layoutSelector": {},
    "mobileOptBarMore": {},
    "confirmActionBar": {
      "icon": "fak fa-lv-check"
    },
    "rejectActionBar": {},
    "multiSelector": {
      "icon": "fak fa-lv-copy",
      "iconOpts": {
        "style": {
          "fontSize": "14px"
        }
      },
      "iconPosition": "end"
    },
    "closeDialog": {
      "icon": "https://recovr-ui-assets.storage.googleapis.com/close.png",
      "imageOpts": {
        "height": "16px",
        "width": "16px"
      }
    },
    "primaryFullWidth": {},
    "formSearchBarPost": {
      "icon": "https://recovr-ui-assets.storage.googleapis.com/close.png",
      "imageOpts": {
        "height": "16px",
        "width": "16px"
      }
    },
    "copyHoursSubmit": {},
    "linkDestructiveNoPad": {},
    "linkNeutral": {},
    "linkNeutralNoPad": {},
    "sortFilterBar": {},
    "quaternary": {},
    "copyToClipboard": {
      "icon": "fak fa-lv-copy",
      "iconPosition": "end"
    },
    "copyToClipboardButton": {
      "icon": "fak fa-lv-copy",
      "iconPosition": "end"
    },
    "conditionBar": {
      "iconOpts": {
        "style": {
          "fontSize": "16px"
        }
      },
      "imageOpts": {
        "height": "20px",
        "width": "20px"
      }
    },
    "sortAdd": {},
    "confirmMobileActionBar": {
      "icon": "fak fa-lv-check"
    },
    "rejectMobileActionBar": {},
    "uploadFile": {
      "icon": "fak fa-lv-single-image",
      "iconOpts": {
        "style": {
          "fontSize": "20px",
          "padding": ""
        }
      },
      "iconPosition": "end"
    },
    "viewImage": {
      "icon": "fa fa-fw fa-image",
      "iconOpts": {
        "style": {
          "fontSize": "20px",
          "padding": ""
        }
      }
    },
    "secondarySmallLeftIcon": {
      "icon": "fak fa-lv-update",
      "iconOpts": null
    },
    "dangerSmallLeftIcon": {
      "icon": "fak fa-lv-delete",
      "iconOpts": null
    },
    "menuItem": {},
    "mobileOptBack": {
      "icon": "fak fa-lv-chevron-left-large",
      "iconOpts": {
        "style": {
          "fontSize": "16px"
        }
      }
    },
    "linkNeutralSmall": {},
    "ruleApply": {
      "icon": "fak fa-lv-check"
    },
    "ruleRevert": {
      "icon": "fa-sharp fa-solid fa-arrow-rotate-left"
    },
    "editImage": {
      "icon": "fa fa-fw fa-pencil-square-o",
      "iconOpts": {
        "style": {
          "fontSize": ""
        }
      }
    },
    "fakeList": {
      "icon": "fa fa-fw fa-chevron-right"
    },
    "tableGotoLink": {},
    "customText": {},
    "secondaryDestructive": {},
    "submit": {},
    "copyToClipboardIcon": {
      "icon": "fak fa-lv-copy",
      "iconPosition": "end"
    },
    "customTextMenu": {
      "iconOpts": {
        "style": {
          "fontSize": "16px"
        }
      },
      "imageOpts": {
        "height": "20px",
        "width": "20px"
      }
    },
    "viewImages": {
      "icon": "fa-regular fa-images",
      "iconOpts": {
        "style": {
          "fontSize": "20px",
          "padding": ""
        }
      }
    },
    "tvCollectionViewItem": {},
    "tvNavLogo": {
      "icon": "https://storage.googleapis.com/molten-ui-assets/architect-logo.png",
      "imageOpts": {
        "height": "40px",
        "width": "40px"
      }
    },
    "linkLarge": {},
    "altLoginMethod": {
      "iconOpts": {
        "style": {
          "fontSize": "20px"
        }
      }
    },
    "forgotPasswordLink": {},
    "altLoginMethodSmall": {
      "iconOpts": {
        "style": {
          "fontSize": "20px"
        }
      }
    },
    "revert": {
      "icon": "fa-sharp fa-solid fa-arrow-rotate-left",
      "iconOpts": null
    },
    "confirmActionBarSmall": {
      "icon": "fak fa-lv-check"
    },
    "rejectActionBarSmall": {},
    "confirmAdd": {
      "icon": "fa-fw fa fa-plus"
    },
    "rejectAdd": {
      "icon": "fa-sharp fa-solid fa-arrow-rotate-left fa-fw"
    },
    "confirmDelete": {
      "icon": "fa fa-fw fa-trash"
    },
    "aggregationLabel": {},
    "aggregationValue": {},
    "aggregationTitle": {},
    "rsrcImageDetailTitle": {},
    "rsrcActionBar": {
      "iconOpts": {
        "style": {
          "fontSize": "16px"
        }
      },
      "imageOpts": {
        "height": "20px",
        "width": "20px"
      }
    },
    "rsrcFilterByCreatedAt": {},
    "sortFilterToolbar": {},
    "sortFilterToolbarRight": {},
    "add": {
      "icon": "fa fa-plus"
    },
    "project": {},
    "delete": {
      "icon": "fa fa-trash"
    },
    "tertiaryGray": {},
    "import": {
      "icon": "fa fa-upload"
    }
  }
}